// extracted by mini-css-extract-plugin
export default {"button":"PrimaryButton_button__+KuRS","primary":"PrimaryButton_primary__nQZzb","shine":"PrimaryButton_shine__GXlQm","alternative":"PrimaryButton_alternative__lwr8J"};